'use es6';

import { connect } from 'react-redux';
import { resubscribe } from 'conversations-internal-pub-sub/redux/actions/subscriptions';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import ChatAreaAlertContainer from '../components/ChatAreaAlertContainer';
import { attachmentsErrorForThreadInProps } from '../../file-uploads/selectors/attachmentsErrorForThreadInProps';
import { dismissAttachmentsError } from '../../file-uploads/actions/dismissAttachmentsError';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import { getNetworkErrors } from '../selectors/getNetworkErrors';
import { fetchOlderThreadHistory } from '../../thread-histories/actions/fetchOlderThreadHistory';
import { refreshWithRejectedMessageFilter } from '../../thread-histories/actions/refreshWithRejectedMessageFilter';
import { createNewThread } from '../../thread-create/actions/createNewThread';
import { startPubSub } from '../../pubsub/actions/startPubSub';
import { getRejectedMessage } from '../../pubsub/selectors/getRejectedMessage';
const mapStateToProps = (state, {
  thread
}) => ({
  attachmentsError: attachmentsErrorForThreadInProps(state, {
    thread
  }),
  networkError: getNetworkErrors(state),
  rejectedMessage: getRejectedMessage(state, thread)
});
const mapDispatchToProps = {
  createNewThread,
  dismissAttachmentsError,
  fetchOlderThreadHistory,
  refreshWithRejectedMessageFilter,
  selectAttachmentFile,
  trackInteraction,
  startPubSub,
  resubscribe
};
export default connect(mapStateToProps, mapDispatchToProps)(ChatAreaAlertContainer);